import UIkit from 'uikit'
import i18next from 'i18next'

export function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                localStorage.setItem("loggedOutMessage","Session expired. Re-login plz!");

                window.location.reload(true);
            }else if (response.status === 406){
                UIkit.notification({
                    message: i18next.t(data.message),
                    status: 'danger',
                    timeout: 5000
                });
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}